import { render, staticRenderFns } from "./BaseHeaderFilterSelect.vue?vue&type=template&id=8c534ab6&scoped=true&"
import script from "./BaseHeaderFilterSelect.vue?vue&type=script&lang=js&"
export * from "./BaseHeaderFilterSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeaderFilterSelect.vue?vue&type=style&index=0&id=8c534ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c534ab6",
  null
  
)

export default component.exports